import { queryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  actualizarTipoSolicitudCatalogo,
  listarTiposSolicitudCatalogoAdmin,
  type TipoDeSolicitudCatalogo,
} from "@/features/solicitudes-catalogo/services/solicitudes-catalogo.api";

export const tiposSolicitudCatalogoAdminQueryOptions = queryOptions({
  queryKey: qk.adminTiposSolicitudCatalogo,
  queryFn: listarTiposSolicitudCatalogoAdmin,
});

export function useTiposSolicitudCatalogoAdmin() {
  return useQuery(tiposSolicitudCatalogoAdminQueryOptions);
}

export function useActualizarTipoSolicitudCatalogo(opts?: { onGuardado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (t: TipoDeSolicitudCatalogo) => actualizarTipoSolicitudCatalogo(t),
    onSuccess: (t) => {
      toastExito({ title: `Tipo «${t.nombre}» guardado` });
      void qc.invalidateQueries({ queryKey: qk.adminTiposSolicitudCatalogo });
      // Cambian textos/activo (solicitante) y responsables (bandeja y nav).
      void qc.invalidateQueries({ queryKey: qk.tiposSolicitudCatalogoActivos });
      void qc.invalidateQueries({ queryKey: qk.bandejaSolicitudesCatalogo });
      opts?.onGuardado?.();
    },
    onError: toastErrorApi,
  });
}
